import { Modal as BootstrapModal } from 'react-bootstrap/lib';
import { Button, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import VoucherCode from '../../../Components/VoucherCode';
import { FaSpinner } from 'react-icons/fa';
import { useState } from 'react';
import React = require('react');

interface DiscountCodeButtonProps {
  disabled: boolean;
  loading: boolean;
  props: any;
  classStyle?: string;
  isBlock?: boolean;

  callback(): any;
}

export const DiscountCodeButton = ({ disabled, loading, props, callback, classStyle, isBlock = false }: DiscountCodeButtonProps) => {

  const [showModal, setShow] = useState(false);

  const openModal = () => {
    setShow(true)
  }

  const closeModal = () => {
    setShow(false)
  }

  const submit = () => {
    closeModal()
    callback()
  }

  return (
    <>
      <BootstrapModal
        show={showModal}
        onHide={closeModal}
        keyboard={false}
        bsSize="large"
        backdrop="static"
      >
        <ModalHeader closeButton={true}>
          <ModalTitle>Discount</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <VoucherCode {...props} applyCallback={submit}/>
        </ModalBody>
      </BootstrapModal>

      <Button
        bsStyle="primary"
        className={classStyle ? classStyle : 'medium-width edit-quote-button'}
        onClick={openModal}
        block={isBlock}
        disabled={disabled}>
        {loading && (<FaSpinner className="fa-spin"/>)}{'APPLY DISCOUNT'}
      </Button>
    </>
  )
}
